import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalUpdateOrderMemoStoreInterface {
  bibliographyRealId: number
  orderId: number
  onUpdatedCallback?: () => void
}

@Module({
  name: 'ModalUpdateOrderMemoStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalUpdateOrderMemoStore extends BaseStore {
  _isOpen: boolean = false

  _bibliographyRealId: number = 0

  _orderId: number = 0

  _updatedCallback?: () => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get bibliographyRealId(): number {
    return this._bibliographyRealId
  }

  get orderId(): number {
    return this._orderId
  }

  @Mutation
  public open(params: ModalUpdateOrderMemoStoreInterface) {
    this._isOpen = true
    this._bibliographyRealId = params.bibliographyRealId
    this._orderId = params.orderId
    this._updatedCallback = params?.onUpdatedCallback
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public updated(): void {
    if (this._updatedCallback) {
      this._updatedCallback()
    }

    this._isOpen = false
  }
}
